__turbopack_context__.v({
  "badge": "today-module-scss-module__WTd_vW__badge",
  "badge_closed": "today-module-scss-module__WTd_vW__badge_closed",
  "badge_closing": "today-module-scss-module__WTd_vW__badge_closing",
  "badge_limit": "today-module-scss-module__WTd_vW__badge_limit",
  "badge_new": "today-module-scss-module__WTd_vW__badge_new",
  "badge_today": "today-module-scss-module__WTd_vW__badge_today",
  "badge_watching": "today-module-scss-module__WTd_vW__badge_watching",
  "badge_wrap": "today-module-scss-module__WTd_vW__badge_wrap",
  "benefit_card": "today-module-scss-module__WTd_vW__benefit_card",
  "benefit_card_icon": "today-module-scss-module__WTd_vW__benefit_card_icon",
  "benefit_card_label": "today-module-scss-module__WTd_vW__benefit_card_label",
  "benefit_card_title": "today-module-scss-module__WTd_vW__benefit_card_title",
  "benefit_cards_list": "today-module-scss-module__WTd_vW__benefit_cards_list",
  "benefit_cards_title": "today-module-scss-module__WTd_vW__benefit_cards_title",
  "bubble": "today-module-scss-module__WTd_vW__bubble",
  "clock_wrap": "today-module-scss-module__WTd_vW__clock_wrap",
  "contact": "today-module-scss-module__WTd_vW__contact",
  "contact_header": "today-module-scss-module__WTd_vW__contact_header",
  "contact_title": "today-module-scss-module__WTd_vW__contact_title",
  "fire": "today-module-scss-module__WTd_vW__fire",
  "fire_1": "today-module-scss-module__WTd_vW__fire_1",
  "fire_2": "today-module-scss-module__WTd_vW__fire_2",
  "fire_3": "today-module-scss-module__WTd_vW__fire_3",
  "fire_4": "today-module-scss-module__WTd_vW__fire_4",
  "fire_5": "today-module-scss-module__WTd_vW__fire_5",
  "fire_6": "today-module-scss-module__WTd_vW__fire_6",
  "fire_twinkle": "today-module-scss-module__WTd_vW__fire_twinkle",
  "form_desc": "today-module-scss-module__WTd_vW__form_desc",
  "inner": "today-module-scss-module__WTd_vW__inner",
  "is_pulling": "today-module-scss-module__WTd_vW__is_pulling",
  "is_sold_out": "today-module-scss-module__WTd_vW__is_sold_out",
  "item_info": "today-module-scss-module__WTd_vW__item_info",
  "item_price": "today-module-scss-module__WTd_vW__item_price",
  "item_special_price": "today-module-scss-module__WTd_vW__item_special_price",
  "item_thumb": "today-module-scss-module__WTd_vW__item_thumb",
  "lead_form": "today-module-scss-module__WTd_vW__lead_form",
  "lever_frame": "today-module-scss-module__WTd_vW__lever_frame",
  "section_benefit_cards": "today-module-scss-module__WTd_vW__section_benefit_cards",
  "section_benefit_marquee": "today-module-scss-module__WTd_vW__section_benefit_marquee",
  "section_cta": "today-module-scss-module__WTd_vW__section_cta",
  "section_special_offer": "today-module-scss-module__WTd_vW__section_special_offer",
  "slot_box": "today-module-scss-module__WTd_vW__slot_box",
  "slot_box_inner": "today-module-scss-module__WTd_vW__slot_box_inner",
  "slot_column": "today-module-scss-module__WTd_vW__slot_column",
  "slot_countdown": "today-module-scss-module__WTd_vW__slot_countdown",
  "slot_countdown_bar": "today-module-scss-module__WTd_vW__slot_countdown_bar",
  "slot_countdown_colon": "today-module-scss-module__WTd_vW__slot_countdown_colon",
  "slot_countdown_text": "today-module-scss-module__WTd_vW__slot_countdown_text",
  "slot_countdown_time": "today-module-scss-module__WTd_vW__slot_countdown_time",
  "slot_lever": "today-module-scss-module__WTd_vW__slot_lever",
  "slot_lever_hit": "today-module-scss-module__WTd_vW__slot_lever_hit",
  "slot_lever_step": "today-module-scss-module__WTd_vW__slot_lever_step",
  "slot_machine": "today-module-scss-module__WTd_vW__slot_machine",
  "slot_machine_inner": "today-module-scss-module__WTd_vW__slot_machine_inner",
  "slot_machine_panel": "today-module-scss-module__WTd_vW__slot_machine_panel",
  "slot_reel": "today-module-scss-module__WTd_vW__slot_reel",
  "slot_reel_spin": "today-module-scss-module__WTd_vW__slot_reel_spin",
  "slot_sign": "today-module-scss-module__WTd_vW__slot_sign",
  "slot_sign_bg": "today-module-scss-module__WTd_vW__slot_sign_bg",
  "slot_strip": "today-module-scss-module__WTd_vW__slot_strip",
  "slot_strip_item": "today-module-scss-module__WTd_vW__slot_strip_item",
  "slot_time": "today-module-scss-module__WTd_vW__slot_time",
  "slot_title": "today-module-scss-module__WTd_vW__slot_title",
  "slot_update_flicker": "today-module-scss-module__WTd_vW__slot_update_flicker",
  "sold_out": "today-module-scss-module__WTd_vW__sold_out",
  "special_offer_item": "today-module-scss-module__WTd_vW__special_offer_item",
  "special_offer_list": "today-module-scss-module__WTd_vW__special_offer_list",
  "submit": "today-module-scss-module__WTd_vW__submit",
  "submit_visual": "today-module-scss-module__WTd_vW__submit_visual",
  "title": "today-module-scss-module__WTd_vW__title",
  "title_group": "today-module-scss-module__WTd_vW__title_group",
  "today_flow_root": "today-module-scss-module__WTd_vW__today_flow_root",
});
